import { User } from '../../types';

export function getFullName(user: User = {} as User) {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim();
}
